var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogoMandalaDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9281 19.9512H39.9869V40.0106H19.9281V19.9512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9281 19.9512H39.9869V40.0106H19.9281V19.9512Z",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 21,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9288 1.00938H39.9863V18.5894H19.9288V1.00938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 21,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9575 1.00938L39.9863 18.5894H19.9288L29.9575 1.00938Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9575 1.00938L39.9863 18.5894H19.9288L29.9575 1.00938Z",
    stroke: "white",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 19,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.497498 19.9975H18.0775V40.055H0.497498V19.9975Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 19,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.497498 30.0262L18.0775 19.9975V40.055L0.497498 30.0262Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.497498 30.0263L18.0775 19.9975L18.0775 40.055L0.497498 30.0263Z",
    stroke: "white",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 41,
    width: 22,
    height: 18
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9744 41.4081H40.0325V58.9881H19.9744V41.4081Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 41,
    width: 22,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0031 58.9881L19.9744 41.4081H40.0325L30.0031 58.9881Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0031 58.9881L19.9744 41.4081H40.0325L30.0031 58.9881Z",
    stroke: "white",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 19,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 19.9512H59.5019V40.0094H41.9219V19.9512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 19,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5019 29.9806L41.9219 40.0094V19.9512L59.5019 29.9806Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5019 29.9806L41.9219 40.0094V19.9512L59.5019 29.9806Z",
    stroke: "white",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoMandalaDark);
export default __webpack_public_path__ + "static/media/new_logo_mandala_dark.25853a4e161ea938dfabf2bce4f7f221.svg";
export { ForwardRef as ReactComponent };